import CustomizedDialogs from "../../components/searchResult/SearchResult";
import { Box, Grid, FormControl, Select } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import ResultCard from "../../components/resultCard/ResultCard";
import styles from "./SearchMenu.module.css";
import { useStyles } from "./classes";
import RefineSearch from "../../components/RefineSearch/RefineSearch";
import Carousel from "../../components/carousel/Carousel";
import axios from "axios";
import ResultsNotFound from "../../components/errorPages/ResultsNotFound";
import Loader from "../../components/Loader/Loader";
import { useSelector } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";

const SearchMenu = (props) => {
  //const [open, setOpen] = React.useState(false)
  const [cards, setCards] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const [isLoading, setLoading] = useState(true);
  const [trendingDishes, setTrendingDishes] = useState([]);
  // const [location, setLocation] = useState('')
  const [ids, setId] = useState("");
  const [types, setType] = useState("");
  const [lngi, setLngi] = useState("");
  const [lati, setLati] = useState("");

  const [values, setValues] = useState({
    restaurantId: "123312413",
    type: "tags",
    filterTags: [],
    id: "6044df84b7e1b9b1d0825f25",
  });

  const refineTags = useSelector((state) => state.showSearch.initialValues);
  const handleClickOpen = (restaurantId) => {
    setValues({
      ...values,
      restaurantId: restaurantId,
      filterTags: refineTags.tags,
    });
    setOpen(true);
  };
  const handleClose = (value) => {
    setOpen(false);
  };

  const classes = useStyles();

  useEffect(() => {
    if (props.location.state) {
      let lng = props.location.state.coordinates.lng;
      let lat = props.location.state.coordinates.lat;
      let id = props.location.state.id;
      let type = props.location.state.type;
      let location = props.location.state.location;
      let name = props.location.state.name;

      //set id, type ,location to component states
      setId(id);
      setType(type);
      setLngi(lng);
      setLati(lat);
      fetchResults(lng, lat, id, type, []);
      setName(name);
      setLocation(location);
    }
    // eslint-disable-next-line
  }, [props.location.state]);

  // const keyword = match.params.keyword

  const fetchResults = async (lng, lat, id, type, tags) => {
    try {
      const { data } = await axios.post("/search", {
        id: id,
        type: type,
        location: {
          lat: lat,
          lon: lng,
        },
        // sort:sort,
        max: 10,
        tags,
      });

   

      setCards(data.data);

      if (data && data.trendingDishes.length) {
        setTrendingDishes(data.trendingDishes);
      }

      console.log("card**********");

      setValues((prev) => {
        return {
          //  restaurantId: data.data[0].restaurantId,
          type: type,
          filterTags: [],
          id: id,
        };
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const [sort, setSort] = React.useState("");

  const handleChange = (event) => {
    // setSort((pre)=>'nearby')
    // console.log('sort',sort)
    if (event.target.value === "nearby") {
      fetchResults(lngi, lati, ids, "sort", event.target.value);
      setSort(event.target.value);
      setLoading(true);
    }
  };

  return (
    <>
      <section>
        <div className={styles.HeroContainer}>
          <h3>
            Restaurants with {name} in {location}
          </h3>
        </div>
      </section>
      <section>
        <div className={styles.Trending}>
          <h2
            style={{
              fontFamily: "Gilroy-ExtraBold, serif",
              marginBottom: "1.5rem",
            }}
          >
            Trending
          </h2>
          <Carousel trendingDishes={trendingDishes} />
        </div>
      </section>
      <section>
        <div className={styles.mainSection}>
          <div className={styles.Search}>
            <Box display="flex" flexWrap="wrap" justifyContent="center">
              <Box flexGrow={1}>
                <h2
                  style={{ fontFamily: "Gilroy-ExtraBold, serif" }}
                  className={styles.Text}
                >
                  Search Results '
                  <span style={{ color: "#d62828" }}>{name}</span>'
                </h2>
              </Box>
              {cards.length === 0 ? (
                ""
              ) : (
                <>
                  <Box>
                    <RefineSearch
                      fetchResults={fetchResults}
                      lat={lati}
                      lng={lngi}
                      type={types}
                      id={ids}
                      name={name}
                      location={location}
                    />
                  </Box>
                  <Box>
                    <FormControl
                      className={classes.formControl}
                      //style={{width:'10rem',marginLeft:'1rem',height:'20px',marginTop:'10px',marginBottom:'10px'}}
                    >
                      <Select
                        // labelId="demo-simple-select-outlined-label"
                        // id="demo-simple-select-outlined"
                        value={sort}
                        onChange={handleChange}
                        displayEmpty
                        label="Sort"
                        inputProps={{ "aria-label": "Without label" }}
                        className={classes.selected}
                      >
                        <MenuItem value="" disabled>
                          Sort by
                        </MenuItem>
                        <MenuItem value="nearby">Nearby</MenuItem>
                        <MenuItem value="1">
                          <em>Rating</em>
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </>
              )}
            </Box>
          </div>
          {isLoading ? (
            <Loader />
          ) : cards.length === 0 ? (
            <ResultsNotFound />
          ) : (
            <Grid className={classes.root}>
              <Grid container>
                {cards.map((card, restaurantId) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    xl={2}
                    style={{ marginBottom: "25px" }}
                  >
                    <ResultCard
                      key={restaurantId}
                      card={card}
                      handleClickOpen={handleClickOpen}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          )}
          <CustomizedDialogs
            values={values}
            open={open}
            closeModal={handleClose}
          />
        </div>
      </section>
    </>
  );
};

export default SearchMenu;
